<div class="amplify-block">
  <div>
    <amplify-authenticator>
      <amplify-sign-out></amplify-sign-out>
    </amplify-authenticator>
  </div>
</div>